<template>

    <!-- v-if="testType(inputelement)" return false ? -->
    <component
      :is="testType(inputelement)"
      :inputelement="inputelement"
      @deleteCritere="deleteFormCritere($event)">
    </component>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputAutoText from './InputAutoText'
import InputAutoDate from './InputAutoDate'
import InputAutoNumber from "./InputAutoNumber";

export default {
  name: 'InputComp',
  props: ['inputelement'],
  components: {
    InputAutoText,
    InputAutoDate,
    InputAutoNumber
  },
  data () {
    return {
      selected: 'contient'
    }
  },
  methods: {
    ...mapActions([
      'emitSaveFieldValue'
    ]),
    deleteFormCritere (element) {
      this.$emit('deleteCritere', element)
    },
    autocomplete (element, type) {
      if (element.hasOwnProperty('autocomplete')) {
        return true
      }
      return false
    },
    testType (element, type) {
      // console.log('testType', element.chTypes);
      // console.log('testType', element.chValues);
      switch (element.chTypes) {
        case 'FT':
          this.selected = 'contient'
          return 'InputAutoText'
        case 'FTE':
          this.selected = 'strict'
          return 'InputAutoText'
        case 'CE':
          this.selected = 'no'
          return 'InputAutoText'
        case 'CFQ':
          this.selected = 'no'
          return 'InputAutoText'
        case 'D':
          this.selected = 'date'
          return 'InputAutoDate'
        case 'CDLT':
          this.selected = 'dateInf'
          return 'InputAutoDate'
        case 'CDGT':
          this.selected = 'dateSup'
          return 'InputAutoDate'
        case 'D+':
          this.selected = 'compris'
          return 'InputAutoDate'
        case 'CV':
          this.selected = 'number'
          return 'InputAutoNumber'
        case 'CVGT':
          this.selected = 'numberSup'
          return 'InputAutoNumber'
        case 'CVLT':
          this.selected = 'numberInf'
          return 'InputAutoNumber'
        case 'CH':
          this.selected = 'number'
          return 'InputAutoNumber'
        case 'CHGT':
          this.selected = 'numberSup'
          return 'InputAutoNumber'
        case 'CHLT':
          this.selected = 'numberInf'
          return 'InputAutoNumber'
      }
      return false
    }
  }
}
</script>

<style scoped>
  .form-list-wrap .uk-label {
    display: inline-block;
    padding: 1px 10px;
    border-radius: 25px;
    text-decoration: none;
    color: #2D3C53;
    font-weight: 600;
    background: #ffffff;
    transition: .4s;
    text-transform: none;
    font-size: 12px;
    min-width: 80px;
  }

  .form-list-wrap .uk-button {
    display: inline-block;
    padding: 0 15px;
    border-radius: 25px;
    text-decoration: none;
    font-weight: 600;
    background: #E9E9E9;
    border: 1px solid #DFDFDF;
    color: #626D7E;
    height: 26px;
    line-height: 26px;
    transition: .4s;
    text-transform: none;
    font-size: 12px;
  }

  .form-list-wrap .uk-button .ops-primary-color {
    color: #0186B1;
  }

  .uk-form-icon-flip ~ .uk-input {
    font-size: 12px;
  }

  .advform .uk-input {
    height: 34px;
    border: 1px solid #E9E9E9;
    border-radius: 6px;
    color: #222222;
    font-size: 12px;
  }

  .ops-simple-input .menu {
    padding: 2px 0 0 15px;
    cursor: pointer;
  }

  .ops-simple-input .menu .uk-icon {
    color: #075068;
  }

  .ops-simple-input .menu .uk-icon:hover {
    color: red;
  }

  .ops-simple-input .uk-form-icon {
    background-color: #075068;
    color: #ffffff;
  }

  .deleteFormCritere {
    float: right;
  }
</style>
